import React from 'react';
import { SectionHeading } from './SectionHeading';
import { useLanguage } from '../contexts/LanguageContext';
import { processSteps } from '../data/about';
import { ui } from '../data/ui';
export function Process() {
  const {
    t
  } = useLanguage();
  return <section id="process" className="section-y bg-white" aria-labelledby="process-title" data-id="element-243" data-mp="1yddwa1sod43c">
      <div className="container-page" data-id="element-244" data-mp="23c7ajwfscz4k">
        <SectionHeading id="process-title" title={t(ui.process.title)} subtitle={t(ui.process.subtitle)} data-id="element-245" data-mp="16oki09lu20we" />
        <div className="relative mt-14" data-id="element-246" data-mp="1aoup5pld2xcu">
          <div className="absolute left-[12%] right-[12%] top-7 hidden h-px bg-line lg:block" aria-hidden="true" data-id="element-247" data-mp="1apvz1qqn5dsz" />
          <ol className="relative grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-248" data-mp="1fmw6a4z88mlo">
            {processSteps.map(({
            icon: Icon,
            title,
            description
          }, i) => <li key={title.en} className="relative flex flex-col items-start lg:items-center lg:text-center" data-id="element-249" data-mp="mza4n29k7s1g" data-mpi={i}>
                <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-navy text-white ring-8 ring-white" data-id="element-250" data-mp="rxbmxkz5vnbv">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-251" data-mp="15jw2w0eby3az" />
                  <span className="absolute -right-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-leaf-strong font-display text-xs font-bold text-white" data-id="element-252" data-mp="15kfjnds8ulnf">
                    {i + 1}
                  </span>
                </span>
                <h3 className="mt-5 font-display text-xl font-bold text-ink" data-id="element-253" data-mp="qv9dt6ywhx6k">{t(title)}</h3>
                <p className="mt-2 max-w-xs leading-relaxed text-body" data-id="element-254" data-mp="lvwu2v3bt687">{t(description)}</p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}